import { connect } from 'react-redux';
import {
    showRemoveConfirmation,
    saveRemoval,
    addProductToBag,
    setLoading,
    saveQuantityChange,
    setExpressDelivery,
    setItemsWithStockIssues,
} from 'Favourites/store/actions';

import {
    selectLists,
    selectSelectedListId,
    selectSelectedListName,
    selectShoppingListView,
} from 'store/reducers/data/shoppingList';


import { selectProduct } from 'Favourites/store/reducers/data/products';
import { LIST_TYPE } from 'Favourites/store/constants';
import getIsPurchasableFoodItem from './isPurchasableFoodItem';

const mapStateToProps = (state, ownProps) => {
    const showRemoveConfirmationState = selectProduct(state, ownProps.article).showRemoveConfirmation;
    const productData = selectProduct(state, ownProps.article);
    const quantity = productData.quantity;
    const selectedList = selectSelectedListId(state);
    const selectedListName = selectSelectedListName(state);
    const lists = selectLists(state);
    const shoppingListView = selectShoppingListView(state);
    const isPurchasableFoodItem = getIsPurchasableFoodItem(productData.articleNumber);

    return { showRemoveConfirmation: showRemoveConfirmationState, productData, quantity, selectedList, selectedListName, lists, shoppingListView, isPurchasableFoodItem };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleRemoveConfirmation: (article, shouldShow) => {
            // Set store flag to show confirmation dialog
            dispatch(showRemoveConfirmation(article, shouldShow, LIST_TYPE));
        },
        removeProduct: (productData, selectedList) => {
            // Calls API to remove article from currently selected shopping list
            dispatch(saveRemoval(productData, selectedList, LIST_TYPE));
        },
        changeQuantity: (productData, selectedList, quantity, quantityDelta) => {
            dispatch(setLoading(productData.articleNumber, true, LIST_TYPE));
            dispatch(saveQuantityChange(productData, LIST_TYPE, selectedList, quantity, quantityDelta));
        },
        addToBag: (article, productName, articleType, quantity) => {
            const product = [{
                ProductName: { $: productName },
                ItemType: { $: articleType },
                ItemNo: { $: article.toString() },
                ItemQty: { $: quantity },
            }];
            dispatch(setLoading(article, true, LIST_TYPE));
            dispatch(addProductToBag(product, LIST_TYPE, true));
        },
        resetStockCheck: () => {
            dispatch(setExpressDelivery(null));
            dispatch(setItemsWithStockIssues(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
